import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ConfigStore } from './core/config-store';
import { SessionStore } from './core/session-store';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, ConfirmDialog],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App implements OnInit {
  // --- private ---
  private readonly _configStore: ConfigStore = inject(ConfigStore);
  private readonly _destroyRef: DestroyRef = inject(DestroyRef);
  // --- protected ---
  protected readonly isDevelopment: boolean = false === environment.production;
  protected readonly store: SessionStore = inject(SessionStore);

  public ngOnInit(): void {
    this.store.initialize().pipe(takeUntilDestroyed(this._destroyRef)).subscribe();
    this._configStore.loadRemote()
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe({
        error: () => {
          /* offline o tabella vuota → fallback default */
        },
      });
  }
}
